import { ChangeDetectionStrategy, Component, HostListener, input } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { ButtonSize } from '../button/button.interface';

@Component({
  standalone: true,
  selector: 'ui-more-menu-trigger',
  templateUrl: './more-menu-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
})
export class MoreMenuTriggerComponent {
  readonly disabled = input<boolean>(false);
  readonly suppressClick = input<boolean>(false);
  readonly border = input<boolean>(false);
  readonly size = input<ButtonSize>('sm');

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    if (!this.suppressClick()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
  }
}
